// extracted by mini-css-extract-plugin
export default {"user":"User-user___LLRtu","user-name":"User-user-name___OkeNk","user-company":"User-user-company___NyVW9","hr":"User-hr___vMMCP"};